<template>
    <div class="helperForShow">
        <template v-if="!item[itemShowKey] && item.orderDetail[showKey].length > 0">
            <span v-if="item.orderDetail[showKey].length === 0" class="editOneLine__text">{{ onlyForShowText }}</span>
            <span v-if="item.orderDetail[showKey].length > 0" class="editOneLine__text">{{
                helperShow(item.orderDetail[showKey]) }} </span>
        </template>
        <template v-if="!item[itemShowKey] && item.orderDetail[showKey].length === 0">
            <span class="editOneLine__text">{{ onlyForShowText }}</span>
        </template>
    </div>
</template>

<script>
// 助理顯示(只有顯示)，一點進Drawer看到的樣子
import helperMixin from '@src/mixins/helperMixin'
export default {
    name: 'HelperForShow',
    components: {},
    mixins: [helperMixin],
    props: {
        itemShowKey: {
            type: String,
            require: true,
            default: ''
        },
        item: {
            type: Object,
            require: true,
            default: () => { }
        },
        showKey: {
            type: String,
            require: true,
            default: ""
        },
        // 當外部有給text時，就顯示外部的text。沒有則顯示default
        onlyForShowText: {
            type: String,
            default: '請選擇'
        }
    },
    data() {
        return {};
    },
    provide() { },
    inject: [],
    computed: {
    },
    watch: {},
    created() { },
    mounted() { },
    methods: {},
};
</script>

<style lang="scss" module>
.helperForShow {
    :global {
        .editOneLine {
            &__title {
                margin: 0;
                font-size: 14px;
                color: #6c6c6b
            }

            &__text {
                font-size: 14px;
                margin-right: 15px;
            }
        }
    }
}
</style>
